"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SPECIAL_FRAGMENT", {
    enumerable: true,
    get: ()=>SPECIAL_FRAGMENT
});
const _graphqlRequest = require("graphql-request");
const SPECIAL_FRAGMENT = (0, _graphqlRequest.gql)`
    fragment specialFragment on Special {
        id
        name
        type
        redemptionLimit
        menuType
        emailConfiguration {
            description
            descriptionHtml
            subject
            heading
            enabled
        }
        scheduleConfiguration {
            startStamp
            endStamp
            days
            setEndDate
            endDate
            recurringStartTime
            recurringEndTime
        }
        menuDisplayConfiguration {
            name
            description
            image
        }
    }
`;
